import React from 'react'
import PropTypes from 'prop-types'

import ShareableButton from "./components/ShareableButton";
import FilterSelect from './components/FilterSelect'
import FiltersContext from "./contexts/Filter";
import { filterData } from './utilities'

const Filters = ({ filters, options, onChange, className, children, shareable, defaultFilters }) => {
  return (
    <FiltersContext.Provider value={{ filters, options, onChange }}>
      <div className={`row mb-3 ${className}`}>
        {children}

        {shareable && (
          <div className="col-1 d-flex justify-content-end" style={{ marginTop: '30px' }}>
            <ShareableButton {...{ filters, defaultFilters }} />
          </div>
        )}
      </div>
    </FiltersContext.Provider>
  )
}

Filters.Select = FilterSelect

Filters.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.object).isRequired,
  defaultFilters: PropTypes.arrayOf(PropTypes.object),
  options: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  shareable: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
}

Filters.defaultProps = {
  options: [],
  defaultFilters: [],
  shareable: false,
  className: '',
}

export default Filters
export { Filters, filterData }
